import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import './Delete.css';
import ConfirmationModal from '../ConfirmationModal/ConfirmationModal';

const Delete = ({ 
  onDelete, 
  itemName = "item",
  className = "",
  size = "medium", // small, medium, large
  successMessage = "",
  onSuccess
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = (e) => {
    e.stopPropagation(); // Prevent event bubbling
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const confirmDelete = async () => {
    try {
      const result = await onDelete();
      closeModal();

      const resolvedMessage = typeof result === 'string'
        ? result
        : result?.message || successMessage;

      if (onSuccess) {
        onSuccess(resolvedMessage);
      } else if (successMessage && resolvedMessage) {
        alert(resolvedMessage);
      }
    } catch (error) {
      console.error('Error deleting item:', error);
      alert('Failed to delete item');
    }
  };

  return (
    <>
      <button 
        className={`delete-button ${size} ${className}`} 
        onClick={openModal}
        title={`Delete ${itemName}`}
      >
        <FontAwesomeIcon icon={faTrash} />
      </button>
      <ConfirmationModal
        isOpen={isModalOpen}
        onClose={closeModal}
        onConfirm={confirmDelete}
        message={`Are you sure you want to delete this ${itemName}?`}
      />
    </>
  );
};

export default Delete;
